import React from 'react'
import { Link } from 'react-scroll';

export default function Navlist() {
    return (
        <nav className={`navbar-nav`}>
            <ul className="navlist">
                <li><Link to="about" spy={true} smooth={true} offset={50} duration={500} style={{ cursor: 'pointer' }} activeClass='activate'><div><span>01. </span>About</div></Link></li>
                <li><Link to="skills" spy={true} smooth={true} offset={50} duration={500} style={{ cursor: 'pointer' }} activeClass='activate'><div><span>02. </span>Skills</div></Link></li>
                <li><Link to="projects" spy={true} smooth={true} offset={50} duration={500} style={{ cursor: 'pointer' }} activeClass='activate'><div><span>03. </span>Projects</div></Link></li>
                <li><Link to="contact" spy={true} smooth={true} offset={50} duration={500} style={{ cursor: 'pointer' }} activeClass='activate'><div><span>04. </span>Contact</div></Link></li>
            </ul>
        </nav>
    )
}
